import React, { useState } from 'react';
import { Button, Modal, Form, Input } from 'antd';

const MakeAddForm = ({ visible, onCreate, onCancel }) => {

    const [form] = Form.useForm();

  return (
    <Modal
      visible={visible}
      title="Create a new collection"
      okText="Create"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}

    >
      <Form
        form={form}
        layout="vertical"
        name="MakeForm"
        initialValues={{
          MakeID:'',
          Make:''
      }}
      >
        {/* <Form.Item
          name="MakeName"
          label="Make Name"
        >
          <Input />
        </Form.Item> */}
        <Form.Item name="Make" label="Enter a car Manufacturer">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const MakeAdd = (props) => {
  const [visible, setVisible] = useState(false);

  const onCreate = (values) => {
    props.addMake(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}
      >
        Add New Manufacturer
      </Button>
      <MakeAddForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
      />
    </div>
  );
};

export default MakeAdd